import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import type { HighlightedTextPart } from '../common/utils/index.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const Mark = styled.mark({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.background.selected.hovered'),

	color: token('color.text'),
});

export type Props = {
	parts: HighlightedTextPart[];
};

const HighlightText = ({ parts }: Props) => (
	<>
		{parts.map((part, i) => {
			if (part.type === 'text') {
				return part.content;
			}

			return <Mark key={i}>{part.content}</Mark>;
		})}
	</>
);

export default HighlightText;
